import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { LocalizationProvider  } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import Layout from "./components/shared/layout/Layout";
import { useHistory } from "react-router-dom";
import * as userActions from "./store/actions/user";
import * as appActions from "./store/actions/app";
import * as policiesActions from "./store/actions/policies";
import { useDispatch, useSelector } from "react-redux";
import useGAEventTracker from "./hooks/useGAEventTracker";
import useQuery from "./hooks/useQuery";
import ReactGA from "react-ga";
import { apps } from "../src/constants/data";
import { COMMERCIAL, PERSONAL } from "./constants/keys";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import { setOktaAuth } from "./utilities/oktaUtilities";

function App() {
  const dispatch = useDispatch();
  const history = useHistory();
  let query = useQuery();
  let path = useLocation();
  let authenticated = useSelector((state) => state.user.agentAuthenticated);
  let employeeAuthenticated = useSelector(
    (state) => state.user.employeeAuthenticated
  );
  let app = useSelector((state) => state.app.app);
  let isAnon = useSelector((state) => state.app.isAnonymous);
  const [queryInfo, setQueryInfo] = useState(query);
  const view = useSelector((state) => state.app.view);
  const origin = useSelector((state) => state.app.origin);
  const ccUser = useSelector((state) => state.user.userInfo);

  ReactGA.initialize("UA-1548613-31");
  const GAEvent = useGAEventTracker("User Login");

  history.listen((location) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });
  const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_OKTA_ISSUER_URL,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_OKTA_LOGOUT_URI,
    scopes: ['openid', 'profile', "okta.myAccount.email.read", "okta.myAccount.email.manage", 'offline_access'],
    tokenManager: {
      autoRenew: true,
    }
  });
  setOktaAuth(oktaAuth);

  const restoreOriginalUrl = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  useEffect(() => {
    if (window.location.hostname === "localhost") {
      const theQuery = query || queryInfo;
      const tokens = JSON.parse(theQuery?.get("ud"))?.oktaTokens;
      if (tokens) {
        localStorage.setItem("okta-token-storage", tokens);
      }
    }
    dispatch(appActions.getIdleSettings());
  }, [])


  useEffect(() => {
      if (JSON.parse(queryInfo.get("land"))) {
        sessionStorage.removeItem("appState");
        dispatch(appActions.setAnonymous(false));
      }//if arrive with query parameters, not anonymous
    let appState = JSON.parse(sessionStorage.getItem("appState"));
    let theOrigin, theView = JSON.parse(queryInfo.get("land"))?.type;
    if (theView) { 
      //arrival with query parameters
      sessionStorage.removeItem("appState");
      theOrigin = JSON.parse(queryInfo.get("loc"));
      dispatch(appActions.setAnonymous(false));
      dispatch(appActions.setOrigin(theOrigin));
    }
    else if (appState) {
      // from session storage - reload
      theOrigin = appState.app.origin;
      theView = appState.app.view;
      dispatch(appActions.setAnonymous(appState.app.isAnonymous));  
      dispatch(appActions.setOrigin(theOrigin));
    }
    else if (isAnon) {
      //initial anonymous arrival
      theOrigin = {
        type: "anon",
        url: process.env.REACT_APP_CUSTOMER_CARE_URL,
      };
      theView = "fileaclaim";
      dispatch(appActions.setOrigin(theOrigin));
    }
    else {
      // authenticated, navigating to a different route
      theView = path.pathName?.substring(1);
    }
    dispatch(appActions.setView(theView));
  }, [queryInfo])

    useEffect(() => {
      if (view) {
        switch (view) {
        case "mlumpolicies":
        case "operators":
        case "operators-a":
        case "questionnaire":
        case "questionnaire-a":
          dispatch(appActions.setApp(apps.DriveRight));
          break;
        case "envelopes":
          dispatch(appActions.setApp(apps.Esignature));
          break;
        default:
          dispatch(appActions.setApp(apps.Claims));
          break;
      }
    }
  }, [dispatch, view]);
  useEffect(() => {
    let tokenInterval;
    if (queryInfo && origin && view) {
      const doAuthenticate =
        !authenticated && !employeeAuthenticated && app && !isAnon;

      const key = JSON.parse(queryInfo.get("key"));
      const policyType = queryInfo.get("policy") === "PERS" ? PERSONAL : COMMERCIAL;
      const accountIDs = JSON.parse(queryInfo.get("acc"));
      const agent = JSON.parse(queryInfo.get("agent"));
      const info = JSON.parse(queryInfo.get("ud"));
      const appState = JSON.parse(sessionStorage.getItem("appState"));

      if (doAuthenticate) {
        // Only authenticate user after config has been loaded
        dispatch(appActions.getConfig()).then(() => {
          if (key !== null) {
            const agentInfo = {
              agentCode: agent.agentCode,
              parentCode: agent.parentCode,
              userId: agent.userId,
              userName: agent.userName,
              userClass: agent.userClass,
              impersonator: agent.impersonator,
            };

            if (app === apps.Claims || agent.agentCode) {
            dispatch(userActions.authenticateAgent(key.token, agentInfo));
            } else {
            dispatch(userActions.authenticateEmployee(key.token, agentInfo));
            }

            dispatch(userActions.setAgent(agentInfo));
            if (!appState) {
              GAEvent("Agent Log In", agentInfo.agentCode);
            }
            sessionStorage.setItem("agent-info", JSON.stringify(agentInfo));
          } else {
           
            if (!appState) {
              if (!ccUser) {
                const userInfo = appState?.user?.userInfo
                ? appState.user?.userInfo
                : {
                    UserId: info.ui,
                    AccountId: info.ai,
                    RefreshToken: info.rt,
                    SessionId: info.si,
                    IsImpersonate: info.ii,
                    UserFullName: info.full,
                    UserEmailId: info.eid,
                  };
                dispatch(
                  userActions.setUser(appState?.user?.userInfo || userInfo)
                );

                GAEvent("Insured Log In", userInfo.UserId);
              }
             
              sessionStorage.setItem("ud", queryInfo.get("ud"));
              sessionStorage.setItem("policy", queryInfo.get("policy"));
              sessionStorage.setItem("acc", queryInfo.get("acc"));

            }

            
            if (queryInfo.get("policy") && appState) {
              appState.app.policyType.active = policyType;
            }

            if ((!appState || appState == {}) && accountIDs) {
              dispatch(
                appActions.setPolicyType(accountIDs.P, accountIDs.C, policyType)
              );
            } else {
              dispatch(
                appActions.setPolicyType(
                  appState.app.policyType.personal,
                  appState.app.policyType.commercial,
                  appState.app.policyType.active
                )
              );
            }

           
          }

          if (origin?.type === "cc" || appState?.app.origin.type === "cc") {
            if (app === apps.DriveRight) {
              const policy =
                queryInfo.get("selectedPolicy") ||
                appState?.policies.activePolicy?.PolicyNumber;
                dispatch(policiesActions.setActivePolicy({ PolicyNumber: policy }));
              }
          }
          sessionStorage.removeItem("appState");

          history.push(`/${view}`);
        });
      } else if (authenticated || employeeAuthenticated) {
        // In ELSE so that token checks happen after authentication (Agent\Employee only)
        dispatch(appActions.getRefreshToken("agent"));
        tokenInterval = setInterval(() => {
          dispatch(appActions.getRefreshToken("agent"));
        }, 180000);
      } else if (isAnon) {
        let anonUser = { UserFullName: "Customer" };
        dispatch(appActions.getConfig());
        dispatch(userActions.setUser(anonUser));
        sessionStorage.removeItem("appState");
       history.push(`/${view}`);
      }
    }

    window.onbeforeunload = () => {
      dispatch(appActions.saveStateToSession());
    };
    return () => {
      clearInterval(tokenInterval);
      window.onbeforeunload = null;
    };
  }, [dispatch, authenticated, employeeAuthenticated, app, queryInfo, origin?.type]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
      const pathView = history.location.pathname.substring(1);
      if (pathView && typeof(pathView) === 'string') {//checking type to avoid object load on initial query
        dispatch(appActions.setView(pathView));
      }
  }, [history.location.pathName])

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUrl}>
        <Layout />
      </Security>
    </LocalizationProvider>
  );
}

export default App;
